"use client"

import { useState } from "react"
import "./FAQSection.css"

const faqData = [
  {
    question: "When should my business consider digital transformation?",
    answer:
      "Your business should consider digital transformation when you're looking to improve efficiency, enhance customer experience, or stay competitive in your industry.",
  },
  {
    question: "What is the difference between digital transformation and digital acceleration?",
    answer:
      "Digital transformation is a comprehensive overhaul of business processes using technology, while digital acceleration focuses on speeding up existing digital initiatives.",
  },
  {
    question: "How can digital transformation benefit my company's online presence and customer engagement?",
    answer:
      "Digital transformation can enhance your online presence through improved websites, mobile apps, social media integration, and personalized customer experiences.",
  },
  {
    question:
      "Do you provide end-to-end digital transformation solutions, or do I need to have an existing plan in place?",
    answer:
      "We provide comprehensive end-to-end digital transformation solutions, from strategy development to implementation and ongoing support.",
  },
  {
    question: "What technologies and tools do you use to support digital transformation projects?",
    answer:
      "We utilize cloud platforms, AI/ML tools, automation software, analytics platforms, and modern development frameworks to support transformation projects.",
  },
  {
    question: "How do you tailor digital transformation solutions to meet the unique needs of my business?",
    answer:
      "We conduct thorough assessments of your current processes, understand your business goals, and create customized solutions that align with your specific requirements.",
  },
  {
    question:
      "Can you provide examples of successful digital transformation projects you've completed for similar businesses?",
    answer:
      "We have successfully helped businesses across various industries implement digital solutions, resulting in improved efficiency, cost savings, and enhanced customer satisfaction.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section189">
          <h1 className="main-title189">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title189">DIGITAL TRANSFORMATION</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
